import mutations, { clampWidth, WIDTH_KEY } from './mutations';
import getters from './getters';

/**
 * Estado do painel da Clara.
 *
 * Só ABERTURA e LARGURA vivem aqui. A conversa em si permanece no
 * ClaraPanel.vue — o painel é montado uma única vez em App.vue, fora do <Menu>,
 * então o estado dele já sobrevive à navegação.
 *
 * Isso importa: antes o chat vivia dentro do <Menu>, que App.vue remonta via
 * `:key` sempre que os acessos do usuário mudam ou o token é renovado. Qualquer
 * um desses eventos apagava a conversa no meio do uso.
 */
export const OPTIONS_STORE_CLARA = {
  MUTATIONS: {
    SET_OPEN: 'clara/setOpen',
    TOGGLE: 'clara/toggle',
    SET_WIDTH: 'clara/setWidth',
    REQUEST_CONVERSATION: 'clara/requestConversation',
    CLEAR_REQUEST: 'clara/clearRequest'
  },
  GETTERS: {
    IS_OPEN: 'clara/isOpen',
    WIDTH: 'clara/width',
    CONTENT_OFFSET: 'clara/contentOffset',
    REQUEST: 'clara/request'
  }
};

const DEFAULT_WIDTH = 420;

function initialWidth() {
  try {
    const stored = Number(localStorage.getItem(WIDTH_KEY));

    return stored ? clampWidth(stored) : DEFAULT_WIDTH;
  } catch (e) {
    return DEFAULT_WIDTH;
  }
}

export default {
  /* `state` e FUNCAO, nao objeto: como objeto, duas stores criadas a partir
     deste modulo dividiriam o mesmo estado. No app so existe uma store, entao
     nao aparecia — mas em teste, onde cada caso monta a sua, um caso enxergava
     o pedido do anterior. */
  state() {
    return {
      open: false,
      width: initialWidth(),
      /* `seq` sobe a cada pedido para o watch do painel disparar mesmo quando
         o contexto pedido e identico ao anterior. */
      request: { customer: null, operation: null, seq: 0 }
    };
  },
  getters,
  mutations,
  namespaced: true
};
